"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
exports.enumOf = (...values) => yup.string().oneOf(values);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLHlDQUEwQjtBQUViLFFBQUEsTUFBTSxHQUFHLENBQW1CLEdBQUcsTUFBb0IsRUFBRSxFQUFFLENBQy9ELEdBQUcsQ0FBQyxNQUFNLEVBQTBCLENBQUMsS0FBSyxDQUFDLE1BQWEsQ0FBQyxDQUFBIn0=